import type { StoreReadOnly } from './create'

/**
 * Run a function every time a given value mutates in the store
 */
export const onStateChange = <T, TSubset>(
	/** Target store */
	store: StoreReadOnly<T>,
	/** Function returning observed part of state */
	selector: (state: T) => TSubset,
	/** Function run on any changes, return a cleanup function to run before next onchange runs */
	onChange: (value: TSubset) => void | Promise<void> | (() => void),
	/** Function to compare two state subsets. Default is triple equality */
	isEqual = (a: TSubset, b: TSubset) => a === b,
) => {
	let last = selector(store.getState())
	let cleanup: void | Promise<void> | (() => void)

	return store.subscribe(() => {
		const current = selector(store.getState())
		if (!isEqual(current, last)) {
			last = current
			if (typeof cleanup === 'function') cleanup()
			cleanup = onChange(current)
		}
	})
}
